import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LaminaApi from '@common/requisicaoCongelacao/tabs/lamina/lamina.api';
import * as commonActions from '@common/common.action';
import CommonFunctions from '@common/util/functions.common';
import { Container, Badge } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import { colorsSystem } from '@common/util/defaultValues';
import IntlMessage from '../../../../helpers/intlMessage';

function LaminasCongelacao ({ laudo }) {
  const dispatch = useDispatch();
  const [lista, setLista] = useState([]);
  useEffect(() => {
    laudo && getLaminas(laudo);
  }, [laudo]);

  const getLaminas = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));

    LaminaApi.getListagemLaminas(laudoId).then(resp => {
      const dataFormated = resp.map(item => ({
        ...item,
        dataCadastro: CommonFunctions.formatDateHour(item.dataCadastro),
        laminaFormated: (
          <span>
            {`${item.lamina} `}
            {item.laminaCancelada && (
              <Badge
                style={{
                  fontSize: '10px',
                  backgroundColor: colorsSystem.VERMELHO,
                  color: '#fff'
                }}
              >
                CANCELADA
              </Badge>
            )}
          </span>
        ),
      }));
      setLista(dataFormated);
      dispatch(commonActions.showFadeCarregando(false));
    });
  };
  return (
    <Container fluid className='mv-workspace-container'>
      <DataTable
        value={lista}
        responsive={true}
        selectionMode='single'
        style={{ height: '100%' }}
        columnResizeMode='expand'
        scrollable={true}
        scrollHeight='71vh'
        scrollWidth='100%'
        resizableColumns={true}
        reorderableColumns={true}
        rowsPerPageOptions={[10, 20, 50]}
        lazy={false}
        paginator={false}
        emptyMessage={<IntlMessage id = "dashboards.examDetail.table.noResultsFound"/>}
        alwaysShowPaginator={true}
        autoLayout={true}
        totalRecords={lista.length}
        onSelectionChange={e => {}}
      >
        <Column
          sortable={true}
          field='bloco'
          style={{ width: '200px' }}
          header={<IntlMessage id = "dashboards.examDetail.block"/>}
        />
        <Column
          sortable={true}
          field='laminaFormated'
          style={{ width: '150px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.blade"/>}
        />
        <Column
          sortable={true}
          field='dsComplemento'
          style={{ width: '150px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.complement"/>}
        />
        <Column
          sortable={true}
          field='nomeMedico'
          style={{ width: '180px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.pathologist"/>}
        />

        <Column
          sortable={true}
          field='nomeTecnico'
          style={{ width: '250px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.technician"/>}
        />
        <Column
          sortable={true}
          field='dataCadastro'
          style={{ width: '180px' }}
          header={<IntlMessage id = "dashboards.examDetail.table.registrationDate"/>}
        />
      </DataTable>
    </Container>
  );
}

export default LaminasCongelacao;



// WEBPACK FOOTER //
// ./src/pages/main/ControleBlocosLaminas/LaminasCongelacao/index.js